import { Injectable, inject, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExternalNavService {
  private document = inject<Document>(DOCUMENT);

  go(href: string): void {
    this.document.location.href = href;
  }
}
